<div class="container-fluid">
  <div class="">
    <h4><b>Link:</b></h4>
    <br />

    <div class="row">
      <div class="col-12">
        
        <div class="col-3">

          <mat-form-field>
            <mat-label>Location</mat-label>
            <mat-select [(value)]="selectedLocationId" (selectionChange)="updateLink(selectedLocationId)">
              <mat-option *ngFor="let location of Locations" [value]="location.id">
                {{ location.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12">

          <input
          type="text"
          class="form-control"
          name="visitorlink"
          [(ngModel)]="link"
          readonly
          />
        </div>
      </div>
    </div>

    <br />
    <hr />
    <h4><strong>Background </strong></h4>
    <div class="row">
      <div class="col-md-12">
        <img
          style="max-width: 300px"
          *ngIf="!companyLinkedData || companyLinkedData.imgFile == null"
          src="/assets/img/image_placeholder.jpg"
        />
        <img
          style="max-width: 300px"
          *ngIf="companyLinkedData && companyLinkedData.imgFile != null"
          class="img picture-src"
          src="{{ companyLinkedData.imgFile }}"
          id="wizardPicturePreview"
        />
        <div>
          <h3>Change Background</h3>
          <hr />
          <input
            type="file"
            id="wizard-picture"
            (change)="onFileChanged($event)"
          />
        </div>
      </div>
    </div>

    <br />
    <hr />

    <h4><strong>Scope and Policy Text:</strong></h4>
    <br />

    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <textarea
            matInput
            #txtpolicy="ngModel"
            name="txtpolicy"
            [(ngModel)]="policy"
            rows="10"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <button
      class="btn btn-success"
      (click)="savePolicy()"
      [disabled]="savingPolicy || !txtpolicy.dirty"
    >
      <i *ngIf="savingPolicy" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
      Save Scope and Policy Changes
    </button>

    <br />
    <hr />

    <h4><strong>Privacy Policy Text:</strong></h4>
    <br />

    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <textarea
            matInput
            #txtprivacy="ngModel"
            name="txtprivacy"
            [(ngModel)]="privacy"
            rows="10"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <button
      class="btn btn-success"
      (click)="savePrivacity()"
      [disabled]="savingPrivacy || !txtprivacy.dirty"
    >
      <i *ngIf="savingPrivacy" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
      Save Privacy Policy Changes
    </button>

    <br />
    <hr />

    <h4><strong>About us Text:</strong></h4>
    <br />

    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <textarea
            matInput
            #txtabout="ngModel"
            name="txtabout"
            [(ngModel)]="about"
            rows="10"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <button
      class="btn btn-success"
      (click)="saveAboutus()"
      [disabled]="savingAbout || !txtabout.dirty"
    >
      <i *ngIf="savingAbout" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
      Save About us Changes
    </button>
  </div>
</div>
